import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MD - Diabetology",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Diabetic Foot Care Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, DNB - Endocrinology",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Wound Care Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - General Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Diabetic Foot Surgery"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MD - Endocrinology",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Diabetic Neuropathy Expert"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - Vascular Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced Wound Care"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, DNB - Diabetology",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Diabetic Foot Prevention"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Diabetic Foot Ulcer Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert multidisciplinary care for comprehensive diabetic foot ulcer management and prevention of complications.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const DiabeticFootUlcerTreatment = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Comprehensive Diabetic Foot Ulcer Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Advanced Wound Care with 85% Healing Success Rate. Multidisciplinary Approach to Prevent Amputations and Complications.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Emergency Wound Care
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>25%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Diabetics Develop Foot Ulcers</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>85%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Healing Success Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>70%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Amputations Preventable</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>4-12</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Weeks Healing Time</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "causes", label: "Causes", icon: "🔍" },
              { id: "stages", label: "Stages", icon: "🎯" },
              { id: "diagnosis", label: "Diagnosis", icon: "🔬" },
              { id: "treatment", label: "Treatment", icon: "⚕️" },
              { id: "prevention", label: "Prevention", icon: "🔄" },
              { id: "complications", label: "Complications", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Diabetic Foot Ulcer Treatment</span>
            </h2>
          </div>

          {/* What are Diabetic Foot Ulcers */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Diabetic Foot Ulcers
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                Diabetic foot ulcers are open sores or wounds that occur in approximately 25% of diabetic patients, 
                typically located on the bottom of the foot. These ulcers result from a combination of factors including 
                peripheral neuropathy, peripheral arterial disease, and foot deformities, compounded by poor glycemic control.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>High-Risk Locations</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Most common on plantar surfaces of metatarsal heads, heels, and tips of toes. 
                      Areas subject to repetitive pressure and trauma are particularly vulnerable in neuropathic feet.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Healing Challenges</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Impaired wound healing due to hyperglycemia, reduced blood flow, immune dysfunction, 
                      and chronic inflammation. Early intervention and comprehensive management are crucial for prevention of complications.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Causes and Risk Factors */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Causes & Risk Factors
            </h3>

            <div className="row">
              {[
                {
                  title: "Peripheral Neuropathy", 
                  description: "Nerve damage causing loss of sensation, making patients unaware of foot injuries",
                  details: "Most common cause - affects 60-70% of diabetic patients"
                },
                {
                  title: "Peripheral Arterial Disease", 
                  description: "Reduced blood flow to lower extremities impairing wound healing",
                  details: "Present in 30-50% of diabetic foot ulcer patients"
                },
                {
                  title: "Foot Deformities", 
                  description: "Charcot foot, bunions, hammertoes creating pressure points",
                  details: "Increased mechanical stress on specific foot areas"
                },
                {
                  title: "Poor Glycemic Control", 
                  description: "Chronic hyperglycemia impairing immune function and tissue repair",
                  details: "HbA1c >7% significantly increases ulcer risk"
                },
                {
                  title: "Trauma & Pressure", 
                  description: "Ill-fitting footwear, walking barefoot, minor injuries",
                  details: "Often goes unnoticed due to neuropathy"
                },
                {
                  title: "Infection", 
                  description: "Bacterial colonization leading to tissue destruction and delayed healing",
                  details: "Present in 60% of moderate to severe ulcers"
                }
              ].map((cause, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {cause.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {cause.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {cause.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Wagner Classification */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Diabetic Foot Ulcer Classification (Wagner System)
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Grade 0",
                    description: "No open lesions, but presence of high-risk foot (deformities, calluses, neuropathy)",
                    treatment: "Preventive care, education, regular monitoring"
                  },
                  {
                    type: "Grade 1",
                    description: "Superficial ulcer involving full skin thickness but not underlying tissues",
                    treatment: "Debridement, off-loading, advanced dressings"
                  },
                  {
                    type: "Grade 2",
                    description: "Deeper ulcer extending to tendons, joints, or capsule without bone involvement",
                    treatment: "Surgical debridement, antibiotics, wound VAC"
                  },
                  {
                    type: "Grade 3",
                    description: "Deep ulcer with abscess, osteomyelitis, or joint sepsis",
                    treatment: "Surgical drainage, IV antibiotics, possible amputation"
                  },
                  {
                    type: "Grade 4",
                    description: "Localized gangrene (toes, forefoot, heel)",
                    treatment: "Revascularization, limited amputation"
                  },
                  {
                    type: "Grade 5",
                    description: "Extensive gangrene involving entire foot",
                    treatment: "Major amputation (below or above knee)"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Diagnosis & Assessment */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Comprehensive Diagnosis & Assessment
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Clinical Examination</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Wound measurement and characterization</li>
                      <li style={{ marginBottom: "10px" }}>Neurological assessment (10g monofilament test)</li>
                      <li style={{ marginBottom: "10px" }}>Vascular examination (pulses, capillary refill)</li>
                      <li style={{ marginBottom: "10px" }}>Foot deformity evaluation</li>
                      <li>Infection signs assessment</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Diagnostic Tests</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Laboratory studies (CBC, ESR, CRP)</li>
                      <li style={{ marginBottom: "10px" }}>Wound culture and sensitivity</li>
                      <li style={{ marginBottom: "10px" }}>Vascular studies (ABI, Doppler ultrasound)</li>
                      <li style={{ marginBottom: "10px" }}>Radiographic imaging (X-ray, MRI)</li>
                      <li>Bone biopsy for osteomyelitis</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Treatment Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Conservative & Medical Management
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Non-surgical approaches form the foundation of diabetic foot ulcer care, focusing on 
                    wound bed preparation, infection control, and optimizing the healing environment.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Wound Care Essentials:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Regular debridement</li>
                          <li style={{ marginBottom: "8px" }}>Moist wound environment</li>
                          <li style={{ marginBottom: "8px" }}>Infection control</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Off-loading pressure</li>
                          <li style={{ marginBottom: "8px" }}>Advanced dressings</li>
                          <li style={{ marginBottom: "8px" }}>Glycemic control</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Therapies:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>Negative pressure wound therapy</li>
                      <li style={{ marginBottom: "8px" }}>Bio-engineered skin substitutes</li>
                      <li style={{ marginBottom: "8px" }}>Growth factor therapy</li>
                      <li>Hyperbaric oxygen therapy</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Surgical & Interventional Approaches
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Procedures:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Surgical debridement</li>
                      <li style={{ marginBottom: "10px" }}>Revascularization procedures</li>
                      <li style={{ marginBottom: "10px" }}>Tendon lengthening</li>
                      <li style={{ marginBottom: "10px" }}>Bone resection</li>
                      <li>Skin grafting and flaps</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Limb Salvage Procedures:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Angioplasty and stenting</li>
                      <li style={{ marginBottom: "10px" }}>Bypass surgery</li>
                      <li style={{ marginBottom: "10px" }}>Minor amputations</li>
                      <li style={{ marginBottom: "10px" }}>Osteomyelitis management</li>
                      <li>Charcot reconstruction</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Multidisciplinary Team:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Diabetologist/Endocrinologist</li>
                      <li style={{ marginBottom: "10px" }}>Vascular surgeon</li>
                      <li>Podiatrist and wound care specialist</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Healing Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Treatment Timeline & Healing Progression
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Week 1-2",
                    title: "Initial Phase",
                    activities: ["Debridement & cleaning", "Infection control", "Pressure off-loading", "Dressing initiation"]
                  },
                  {
                    period: "Week 3-6",
                    title: "Proliferation Phase",
                    activities: ["Granulation tissue formation", "Wound contraction", "Advanced therapies", "Regular monitoring"]
                  },
                  {
                    period: "Week 7-12",
                    title: "Maturation Phase",
                    activities: ["Epithelialization", "Scar formation", "Gradual weight bearing", "Prevention planning"]
                  },
                  {
                    period: "3+ Months",
                    title: "Maintenance Phase",
                    activities: ["Complete healing", "Footwear modification", "Regular foot exams", "Lifestyle adjustments"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Prevention Strategies */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Prevention & Long-term Management
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Daily Foot Care</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Daily foot inspection</li>
                      <li style={{ marginBottom: "10px" }}>Proper washing and drying</li>
                      <li style={{ marginBottom: "10px" }}>Moisturizing (except between toes)</li>
                      <li>Nail care and callus management</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Preventive Measures</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Appropriate footwear</li>
                      <li style={{ marginBottom: "10px" }}>Never walking barefoot</li>
                      <li style={{ marginBottom: "10px" }}>Regular podiatrist visits</li>
                      <li>Optimal glycemic control</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "How long does it take for a diabetic foot ulcer to heal?",
                  answer: "The healing time for diabetic foot ulcers varies significantly based on several factors: Grade 1 ulcers typically take 4-8 weeks with proper care; Grade 2 ulcers may require 8-12 weeks; Grade 3 and complex ulcers can take 12-24 weeks or longer. Key factors affecting healing time include ulcer size and depth, blood flow adequacy, glycemic control, presence of infection, and patient compliance with off-loading. With comprehensive multidisciplinary care, approximately 60-70% of ulcers heal within 12 weeks, and 85% within 20 weeks. Regular monitoring and appropriate treatment adjustments are crucial for optimal healing progression. Delayed healing beyond 4 weeks should prompt re-evaluation of the treatment plan."
                },
                {
                  question: "Can diabetic foot ulcers be prevented?",
                  answer: "Yes, up to 85% of diabetic foot ulcers can be prevented through comprehensive preventive strategies. Key prevention measures include: Daily foot inspections for any changes or injuries; Proper footwear that fits well and provides adequate support; Regular podiatrist visits for professional foot care; Optimal glycemic control (HbA1c <7%); Smoking cessation to improve circulation; Regular exercise to promote blood flow; Education about foot care and early warning signs. High-risk patients should have comprehensive foot examinations at least annually. Early intervention for any foot problems can prevent minor issues from developing into serious ulcers. Patient education and self-management are the cornerstones of effective prevention."
                },
                {
                  question: "What are the signs of infection in a diabetic foot ulcer?",
                  answer: "Recognizing infection early is crucial for preventing serious complications. Signs of infection include: Increased pain or new pain in a previously painless ulcer; Purulent drainage or foul odor from the wound; Redness extending more than 2cm from the ulcer edges; Swelling and warmth around the ulcer; Fever or chills (systemic signs); Increased blood glucose levels without other explanation; Development of crepitus (gas in tissues). Deep infections may show bone exposure or probe-to-bone test positivity. Any suspected infection requires immediate medical attention as diabetic foot infections can progress rapidly and lead to serious complications including osteomyelitis and sepsis. Early antibiotic therapy and possible surgical intervention may be necessary."
                },
                {
                  question: "Why is off-loading so important in diabetic foot ulcer treatment?",
                  answer: "Off-loading (pressure redistribution) is critically important because continuous pressure on the ulcer prevents healing and causes further tissue damage. In diabetic patients, neuropathy means they often don't feel the pressure, allowing damage to continue unnoticed. Effective off-loading methods include: Total contact casts (gold standard); Removable cast walkers; Therapeutic footwear; Crutches or wheelchairs for non-weight bearing. Studies show that proper off-loading can increase healing rates by 50-80%. Without adequate off-loading, even the most advanced wound care treatments will be ineffective because the underlying mechanical stress continues to damage tissue. Compliance with off-loading recommendations is one of the most important predictors of successful ulcer healing."
                },
                {
                  question: "When is surgery necessary for diabetic foot ulcers?",
                  answer: "Surgical intervention becomes necessary in several scenarios: When there is extensive necrotic tissue requiring surgical debridement; For drainage of abscesses or deep space infections; In cases of osteomyelitis (bone infection) requiring bone resection; When vascular insufficiency requires revascularization procedures; For correction of foot deformities causing recurrent ulcers; When conservative treatments fail after 4-6 weeks; In cases of gangrene requiring amputation. The goal of surgery is always to preserve as much functional tissue as possible while eliminating infection and creating an environment conducive to healing. Modern surgical approaches focus on limb salvage, with major amputations being a last resort. A multidisciplinary team approach ensures the best surgical outcomes."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Need Expert Diabetic Foot Care?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our multidisciplinary team provides comprehensive diabetic foot ulcer treatment with advanced wound care technologies.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Diabetic Foot Care: <strong>080-6541-7705</strong> | Emergency Wound Care: <strong>080-6541-7712</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default DiabeticFootUlcerTreatment;